import { ITelemetryItem } from "@microsoft/applicationinsights-web";
import { TelemetryExclusionBase } from "./TelemetryExclusionBase";

export class PowerBiTelemetryExclusion extends TelemetryExclusionBase {
    constructor(telemetryItem: ITelemetryItem) {
        super(telemetryItem);
    }

    public isActive(): boolean {
        const data = this.telemetryItem.data;
        if (data) {
            const errorSrc = data["errorSrc"];
            if (errorSrc) {
                const errorAsStr = String(errorSrc);
                if (errorAsStr.endsWith("/power-bi-reports:0:0")) {
                    return true;
                }
            }
        }
        return false;
    }
}
